import React from "react";
import LocationUnitGrid from "./LocationUnitGrid";

const LocationUnitPage = () => {
  return (
    <div className="c-main">
      <div className="c-content">
        <LocationUnitGrid />
      </div>
    </div>
  );
};
export default LocationUnitPage;
